module.exports = __webpack_public_path__ + "media/partenaire/misc_clothes-7bd32f9d.png";